import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class NdaDocumentStore extends LocalModel {
    constructor() {
        super('ndaDocument', {
            namePlural: 'ndaDocuments',
            namePluralReal: 'ndadocuments',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/ndadocuments/',
                    params: {
                        limit: 100,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/ndadocuments/',
                    params: {},
                },
                save: {
                    url: '/api/ndadocuments/',
                    params: {},
                },
                delete: {
                    url: '/api/ndadocuments/',
                    params: {},
                },
            },
        });
    }

    @observable newNdaDocument = {};

    @observable ndaDocument = {};

    @observable ndaDocuments = [];

    @action
    clearAll() {
        this.newNdaDocument = {};
        this.ndaDocument = {};
        this.ndaDocuments = [];
    }

    async createDocument({ title, content, status }) {
        const response = await util.fetchApi('/api/ndadocuments/', {
            method: 'POST',
        }, {
            title,
            content,
            status,
        });

        if (response.status === 201) {
            await this.load();
        }

        return response;
    }

    async updateDocument(docId, { title, content, status }) {
        const updateData = { id: docId };

        if (title !== undefined) updateData.title = title;
        if (content !== undefined) updateData.content = content;
        if (status !== undefined) updateData.status = status;

        const response = await util.fetchApi(`/api/ndadocuments/${docId}`, {
            method: 'PATCH',
        }, updateData);

        if (response.status === 202) {
            await this.load();
        }

        return response;
    }

    async deleteDocument(docId) {
        const response = await util.fetchApi(`/api/ndadocuments/${docId}`, {
            method: 'DELETE',
        }, {
            id: docId,
        });

        if (response.status === 200) {
            await this.load();
        }

        return response;
    }
}

const store = new NdaDocumentStore();
export default store;
